<div class="chart-cover">
    <div class="chart-interactive">
        <div class="chart-item">
            <div class="chart-options"></div>
            <div class="chart-wrap">
                <div class="chart-canvas">
                    <ycn-fund-chart-date-zoom
                        *ngIf="!loadingChart"
                        (selectZoomOptionHandler)="setZoomValue($event)"
                        [zoom]="currentZoom"
                        [customCssClasses]="{list: 'chart-control-compact'}">
                    </ycn-fund-chart-date-zoom>
                    <ycn-fundamental-chart
                            class="chart-canvas d-flex flex-column"
                            [configurableOptions]="configurableOptions"
                            [chartOptions]="chartOptions"
                            [chartDataUrl]="chartDataUrl"
                            [noDataClass]="noDataClass"
                            (chartDataHandler)="chartDataHandler($event)"
                            (subchartOffsetsHandler)="subchartOffsetsHandler($event)"
                            (tooltipDataHandler)="tooltipDataHandler($event)">
                    </ycn-fundamental-chart>
                </div>
            </div>
        </div>
    </div>
</div>
